import React from 'react';

import {
	BottomCard,
	BottomCardAction,
	BottomCardForm,
} from '@/components/shared/BottomCard';
import { AsaphButton } from '@/components/shared/Button';
import { Label } from '@/components/shared/Inputs/Label';
import { useGetBiblePassageAnalysisMutation } from '@/graphql';
import { FetchError } from '@/graphql/codegen-fetcher';
import { FormHelperText } from '@material-ui/core';

import { BiblePassageInput } from '../BiblePassageInput/BiblePassageInput';

const AddPassageBottomCard: React.FC<{
	onClose: () => void;
	onSave: (bibleReference?: string) => void;
}> = ({ onClose, onSave }) => {
	const [bibleReference, setBibleReference] = React.useState<string>('');
	const {
		isLoading: isBiblePassageLoading,
		mutateAsync: getBiblePassage,
		error: biblePassageError,
		isError: isBiblePassageError,
		reset: resetBiblePassage,
	} = useGetBiblePassageAnalysisMutation();

	let biblePassageErrorMessage = 'Placeholder';
	if (isBiblePassageError && biblePassageError instanceof FetchError) {
		biblePassageErrorMessage = biblePassageError.message;
	}

	const handleSave = async () => {
		try {
			await getBiblePassage({
				reference: bibleReference,
			});
			onSave(bibleReference);
		} catch (err) {
			console.log(err);
		}
	};

	return (
		<BottomCard title="Add Bible Passage" onClose={onClose}>
			<BottomCardForm>
				<div style={{ position: 'relative' }}>
					<Label
						withOffset
						tooltipHeading="Bible passage"
						tooltip="Match your post-sermon song to the primary passage planned for the sermon. Enter the passage using standard bible citation **Book chapter:verses** (e.g. John 3:16-21)."
					>
						Bible Passage (optional)
					</Label>
					<BiblePassageInput
						placeholder="Genesis 1:1-10"
						name="bibleReference"
						id="bibleReference"
						value={bibleReference}
						onChange={(value) => {
							resetBiblePassage();
							setBibleReference(value);
						}}
						onError={resetBiblePassage}
						error={isBiblePassageError}
					/>
					<div
						style={{
							visibility: isBiblePassageError ? 'visible' : 'hidden',
						}}
					>
						<FormHelperText error={true}>
							{biblePassageErrorMessage}
						</FormHelperText>
					</div>
				</div>
			</BottomCardForm>
			<BottomCardAction>
				<AsaphButton
					isLoading={isBiblePassageLoading}
					onClick={handleSave}
					fullWidth
					label="Save"
					color="blue"
				/>
			</BottomCardAction>
		</BottomCard>
	);
};

export default AddPassageBottomCard;
